export default __webpack_public_path__ + "static/bed-bath-beyond-5-a-4f3b7b2fd347be2a126912b6997ca74c.webp";